module.exports = __webpack_public_path__ + "static/img/zxkf.8600313.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zxkf.png
// module id = C1+O
// module chunks = 3